export default __webpack_public_path__ + "static/media/no-image-placeholder.09cb794a.png";